import React from "react";
import { useRouter } from "next/router";
import queryString from "query-string";
import { capitalizeFirstChar } from "frontend/components/helpers";

export const isServerSide = () => {
    return typeof window === "undefined";
};

export const formatTerm = term => {
    // first capitalizes the first char
    // then capitalizes the first char after every hyphen
    const capFirst = capitalizeFirstChar({ str: term });
    return capFirst.replace(/-[a-z]/g, match => match.toUpperCase());
};

// Pretty-print number based on localization; and support SSR
// by defaulting to US when rendering server-side.
export const getFormattedNumber = num => {
    const localization = isServerSide() ? "en-US" : undefined;
    return Number(num).toLocaleString(localization);
};

// Ability to grab URL query on server-side, client-side, and legacy SPA pages
export const useUrlQuery = () => {
    if (typeof window === "undefined") {
        const router = useRouter();
        return router.query;
    } else {
        return queryString.parse(window.location.search);
    }
};

export const setLocalStorage = (key, data) => {
    const onServer = isServerSide();
    if (onServer) return;
    if (window.localStorage) {
        localStorage.setItem(key, JSON.stringify(data));
    }
};

export const getLocalStorage = key => {
    const onServer = isServerSide();
    if (onServer) return;
    if (window.localStorage) {
        const data = localStorage.getItem(key);
        try {
            return data ? JSON.parse(data) : null;
        } catch (e) {
            return null; // if not valid JSON
        }
    }
    return null;
};

// Fetch, but will retry if network errors occur.
const MAX_RETRIES = 3;
export const tryFetch = async (url, headers, retries = 0) => {
    try {
        const res = await fetch(url, headers);
        return res;
    } catch (error) {
        // network error occurred, try again
        if (retries < MAX_RETRIES) {
            return tryFetch(url, headers, retries + 1);
        }
        return { ok: false, error };
    }
};

// Given user object & team's username, return the team's ID
export const getTeamId = ({ currentUser, teamUser }) => {
    if (teamUser && currentUser && Array.isArray(currentUser.ownedTeams)) {
        const match = currentUser.ownedTeams.find(
            team => team && team.username === teamUser
        );
        if (match && match.id) {
            return match.id;
        }
    }
    return null;
};
